import React, { useEffect, useMemo, useState } from 'react';
import { Sociedad, SociedadesAdapter } from '../../../../../infraestructure/persistence/rest/SociedadesAdapter';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import ComboSociedades from './combo';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import moment from 'moment';
import { FIX_SOCIEDAD_MAESTRO_ADMUSUARIOS } from '../../../../../shared/constanst/constants';

export const ComboSociedadesContainer = (props: any) => {
  
  const api = new SociedadesAdapter();
  const {fechaHasta,admExpatriados,rol,fixSociedad,selectedOptions} = props;
  const { exceptionError, resultError } = useNotifications();
  let [sociedades, setSociedades] = useState<any>(undefined)
  let result: any;
  
  useEffect(()=>{
    console.log('useEffect sociedades')
    if(admExpatriados===true)
    {
      getSociedadesAdministradorExpatriados(rol)
    }else{
    props.user ? getSociedadesUsuario() : getSociedades();
    }
  },[])


	const getSociedadesUsuario = async() =>{
    try {
      result = await api.ListarSociedades(props.user)
      if(result.data && result.data!=="")
			{
        setSociedades([...result.data]);
      }else{resultError()}
    } catch (error) {
      let exception = ServerErrorMessage(error);
      exceptionError(exception)
    }
  }

  const getSociedadesAdministradorExpatriados = async(rol:string) =>{
    try {
      result = await api.ListarSociedadesAdministradorExpatriados(rol)
      if(result.data && result.data!=="")
			{
        setSociedades([...result.data]);
      }else{resultError()}
    } catch (error) {
      let exception = ServerErrorMessage(error);
      exceptionError(exception)
    }
  }

  const getSociedades = async() =>{
    try {
      result = await api.ListarSociedades();
      if(result.data && result.data!=="")
			{
        let _data:any = fixSociedad ? result.data.filter((f:any)=> f.idSociedad===FIX_SOCIEDAD_MAESTRO_ADMUSUARIOS):result.data;
        setSociedades([..._data]);
      }else{resultError()}
    } catch (error) {
      let exception = ServerErrorMessage(error);
      exceptionError(exception)
    }
  }

  const getSociedadesFilter = useMemo(() =>{
    const socFilter = sociedades!==undefined ? 
    (fechaHasta!==undefined ? sociedades.filter((s:Sociedad)=> s.fechaBaja === null || moment(fechaHasta).isBefore(s.fechaBaja)) : sociedades) : []
    return socFilter;
  },[sociedades])


  return <ComboSociedades {...props} options={getSociedadesFilter}/>
};

export default ComboSociedadesContainer;